import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  doubtfulDebtReserves,
  type DoubtfulDebtReserveListItem,
} from '@/api/doubtfulDebtReserves';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';

const fmt2 = (v: string | number) =>
  Number(v).toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function DoubtfulDebtReservesPage() {
  const navigate = useNavigate();
  const list = useQuery({
    queryKey: ['doubtful-debt-reserves'],
    queryFn: () => doubtfulDebtReserves.list({ limit: 200 }),
  });

  const cols = useMemo<ColumnDef<DoubtfulDebtReserveListItem>[]>(() => [
    { key: 'document_number', header: '№', width: 150, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
    {
      key: 'document_date', header: 'Дата', width: 170,
      sortValue: (r) => r.document_date ?? '',
      cell: (r) => r.document_date ? new Date(r.document_date).toLocaleString('uk-UA') : '',
    },
    {
      key: 'total_amount', header: 'Сума резерву', align: 'right',
      sortValue: (r) => Number(r.total_amount),
      cell: (r) => fmt2(r.total_amount),
    },
    {
      key: 'posted', header: 'Проведено', width: 130, align: 'center',
      sortValue: (r) => r.posted ? 1 : 0,
      cell: (r) => (r.posted ? '✓ так' : 'ні'),
    },
  ], []);

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Резерв сумнівних боргів</h2>
        <button className="primary" onClick={() => navigate('/doubtful-debt-reserves/new')}>
          + Новий документ
        </button>
      </div>
      <DataTable<DoubtfulDebtReserveListItem>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає документів."
        onRowDoubleClick={(r) => navigate(`/doubtful-debt-reserves/${r.id}`)}
        rowMuted={(r) => r.deletion_mark ? 0.4 : undefined}
        initialSortKey="document_date"
        initialSortDir="desc"
      />
    </>
  );
}
